var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('a-layout-header',[_c('headerHeader')],1),_c('a-layout-content',[_c('siderHome')],1),_c('a-layout-footer',[_c('footerHome')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }